<script lang="ts">
    import type {SearchParams, StaticSearchParams} from 'typings/portaro.be.types';
    import {SearchType} from 'shared/constants/portaro.constants';
    import {getInjector} from 'core/svelte-context/context';
    import {UrlStateManagerService} from 'shared/state-manager/url-state-manager.service';
    import KpSearchContext from '../kp-search-context/KpSearchContext.svelte';
    import KpFullPageSearch from './KpFullPageSearch.svelte';
    import KpCatalogSearch from './KpCatalogSearch.svelte';

    export let staticParams: Partial<StaticSearchParams>;

    const urlStateManagerService = getInjector().getByClass(UrlStateManagerService<SearchParams>);

    $: urlParams$ = urlStateManagerService.getState$();
</script>

<KpSearchContext {staticParams} let:searchManager>
    {#if $urlParams$?.type === SearchType.TYPE_CATALOG}
        <KpCatalogSearch {searchManager}/>
    {:else }
        <KpFullPageSearch {searchManager}/>
    {/if}
</KpSearchContext>